import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getErrorMessage } from "helpers";
import { applicationTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionViewDto } from "types/api";

import getDefaultValuesTerminalSolution from "../terminalSolutions/getDefaultValuesTerminalSolution";

type useGetTerminalQueryProps = {
	terminalId: string;
	redirectTo?: string;
	terminalAccessoryTypes?: { [key: string]: any }[];
	merchantGeneralData?: any;
	onSuccess?: Function;
	enabled?: boolean;
	applicationId: string;
};

const useGetTerminalSolutionByAppIdQuery = ({
	terminalId,
	redirectTo,
	terminalAccessoryTypes,
	merchantGeneralData,
	onSuccess,
	enabled = true,
	applicationId,
}: useGetTerminalQueryProps) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const queryResult = useQuery(
		["getTerminalSolution", terminalId],
		() =>
			applicationTerminalService.getTerminalSolutionById(
				terminalId,
				applicationId,
			),
		{
			select: (data: TerminalSolutionViewDto) => {
				const terminalSolution: any = getDefaultValuesTerminalSolution({
					data,
					terminalAccessoryTypes,
					merchantGeneralData,
				});

				return terminalSolution;
			},
			onSuccess: data => {
				onSuccess?.(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				redirectTo && history.push(redirectTo);
			},
			enabled: enabled && !!terminalId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetTerminalSolutionByAppIdQuery;
